import React, { useEffect, useRef, useState, useTransition } from "react";
import { Link } from "react-router-dom";
import SideBarSubMenu from "./SideBarSubMenu";
import { useContext } from "react";
import SideBarMenu from "./SideBarMenu";
import Skeleton from "react-loading-skeleton";
import { AuthContext } from "../../../../Contexts/AuthContext/AuthProvider";
const SideBar = ({ menuSHow, setMenuShow }) => {
  const { authUser } = useContext(AuthContext);

  const [notificationData, setNotificationData] = useState([]);

  // useEffect(() => {
  //   const interval = setInterval(fetchData, 2000);
  //   return () => clearInterval(interval);
  // }, []);

  // const fetchData = async () => {
  //   try {
  //     fetch(`https://api.velormall.com/api/admin/notification/user`, {
  //       method: "GET",
  //     })
  //       .then((res) => res.json())
  //       .then((data) => {
  //         if (data) {
  //           setNotificationData(data);
  //         }

  //       })
  //       .catch((error) => {
  //         // console.log(error);
  //       });
  //   } catch (error) {

  //   }
  // };

  const routes = [
    {
      path: "/agent/dashboard",
      name: "Dashboard",
      icon: "menu-icon las la-home",
    },



    {
      name: "Manage Users",
      icon: "menu-icon las la-users",
      notification: notificationData?.TotalUser,
      subRoutes: [
        {
          path: "/agent/active/users",
          name: "Active Users",
          notification: notificationData?.ActiveUser,
        },
        {
          path: "/agent/banned/users",
          name: "Banned Users",
          notification: notificationData?.BannedUser,
        },
        {
          path: "/agent/all/users",
          name: "All Users",
        },
      ],
    },


    {
      path: "/agent/all/deposits",
      name: "All Deposits",
      icon: "menu-icon las la-file-invoice-dollar",
      notification: notificationData?.TotalDeposit,
    },
    {
      path: "/agent/all/withdraws",
      name: "All Withdrawals",
      icon: "menu-icon la la-bank",
      notification: notificationData?.TotalWithdrawal,

    },
    {
      path: "/agent/transaction/logs",
      name: "Transaction Log",
      icon: "menu-icon la la-list",
    },

  ];

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const inputAnimation = {
    hidden: {
      width: 0,
      padding: 0,
      transition: {
        duration: 0.2,
      },
    },
    show: {
      width: "140px",
      padding: "5px 15px",
      transition: {
        duration: 0.2,
      },
    },
  };

  const showAnimation = {
    hidden: {
      width: 0,
      opacity: 0,
      transition: {
        duration: 0.5,
      },
    },
    show: {
      opacity: 1,
      width: "auto",
      transition: {
        duration: 0.5,
      },
    },
  };

  const menuRef = useRef();

  const [mobileMenu, setMobileMenu] = useState();

  useEffect(() => {
    if (menuSHow === true) {
      menuRef.current.style.left = "0px";
    }
    if (mobileMenu === true) {
      menuRef.current.style.left = "-800px";
      setMenuShow(false);
      setMobileMenu(false);
    }
  }, [mobileMenu, menuSHow]);

  return (
    <>
      <div className="default-version">
        <div className="sidebar bg--dark">
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link to="/agent/dashboard" className="sidebar__main-logo d-flex align-items-center justify-content-center">
                {/* <img
                  src="https://res.cloudinary.com/debfkqhc8/image/upload/v1743102297/npxfpnd7fuu3t7monxwv.jpg"
                  alt=""
                /> */}
                <p className="pt-3 m-0 text-light bold fs-6">
                  VMall
                </p>
              </Link>
            </div>

            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      return (
                        <SideBarSubMenu
                          setIsOpen={setIsOpen}
                          route={route}
                          showAnimation={showAnimation}
                          isOpen={isOpen}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        />
                      );
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      return (
                        <SideBarMenu
                          route={route}
                          index={index}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        ></SideBarMenu>
                      );
                    }
                  }
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="default-version desltop-version">
        <div className="sidebar bg--dark" ref={menuRef}>
          <button
            className="res-sidebar-close-btn"
            onClick={() => setMobileMenu(true)}
          >
            <i className="las la-times"></i>
          </button>
          <div className="sidebar__inner">
            <div className="sidebar__logo">
              <Link href="/admin/dashboard" className="sidebar__main-logo">
                {/* <img
                  src=""
                  alt=""
                /> */}
              </Link>
            </div>
            <div className="sidebar__menu-wrapper" id="sidebar__menuWrapper">
              <ul className="sidebar__menu">
                {routes.map((route, index) => {
                  if (authUser?._id === undefined) {
                    return (
                      <>
                        <Skeleton
                          count={20}
                          height={10}
                          baseColor="#202020"
                          highlightColor="#444"
                        />
                      </>
                    );
                  } else {
                    if (route.subRoutes) {
                      return (
                        <SideBarSubMenu
                          setIsOpen={setIsOpen}
                          route={route}
                          showAnimation={showAnimation}
                          isOpen={isOpen}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        />
                      );
                    } else if (route.title) {
                      return (
                        <li className="sidebar__menu-header" key={index}>
                          {route.title}
                        </li>
                      );
                    } else {
                      return (
                        <SideBarMenu
                          route={route}
                          index={index}
                          key={index}
                          setMobileMenu={setMobileMenu}
                        ></SideBarMenu>
                      );
                    }
                  }
                })}



              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;
